// 其他页面
export default[
  {
    path: '/about',
    name: '关于我们',
    component: () => import(/* webpackChunkName: 'other' */ '@/views/other/about.vue')
  },
  {
    path: '/blockDetail/:id',
    name: '区块详情',
    component: () => import(/* webpackChunkName: 'other' */ '@/views/product/blockDetail')
  },
  {
    path: '/approvedProjectsList',
    name: '成交项目列表',
    component: () => import(/* webpackChunkName: 'other' */ '@/views/other/approvedProjectsList')
  },
  {
    path: '/resetPassword',
    name: '重置密码',
    component: () => import(/* webpackChunkName: 'other' */ '@/views/account/resetPassword')
  }
]



// WEBPACK FOOTER //
// ./src/router/moudles/otherRouter.js